/**
 * Handles registration success notifications
 * MSYDB-649
 */
document.addEventListener('DOMContentLoaded', function () {
  const registerForm = document.getElementById('create_customer');
  const formErrors = document.querySelector('.form__message.form-message--error');

  if (registerForm) {
    registerForm.addEventListener('submit', function () {
      sessionStorage.setItem('justRegistered', 'true');
    });
  }

  const hasJustRegistered = sessionStorage.getItem('justRegistered');

  if (!hasJustRegistered) {
    return;
  }

  if (formErrors) {
    sessionStorage.removeItem('justRegistered');
    return;
  }

  if (typeof DreambabyNotificationHandler === 'undefined') {
    return;
  }

  const successMessage = window.registrationStrings?.successMessage || 'Registration successful!';
  DreambabyNotificationHandler.showNotification(successMessage, 'success');
  sessionStorage.removeItem('justRegistered');
});